import { render, staticRenderFns } from "./unqualifiedDestruction.vue?vue&type=template&id=50f8bf84&scoped=true"
import script from "./unqualifiedDestruction.vue?vue&type=script&lang=js"
export * from "./unqualifiedDestruction.vue?vue&type=script&lang=js"
import style0 from "./unqualifiedDestruction.vue?vue&type=style&index=0&id=50f8bf84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f8bf84",
  null
  
)

export default component.exports